/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
import { Flex, Spinner, Text, useDisclosure } from '@chakra-ui/react';
import { gql, useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import useStore from '../../../store';
import IntermediarySaleProfessionalRequestDetailModal from '../../ManageAgentPartner/Intermediary/SaleProfessionalRequest/detail-modal';

const Q = gql`
	query get($number: String!) {
		getIntermediarySaleProfessionalRequestByNumber(number: $number) {
			id
		}
	}
`;

function AgentCompanySaleStaffTermination({ id = null, item = null }) {
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [fetchDetail, { loading, data }] = useLazyQuery(Q);

	useEffect(() => item && fetchDetail({ variables: { number: item?.numDp } }), [item]);

	return (
		<>
			{item && (
				<Flex
					key={`k-num-${id}`}
					style={{ pageBreakInside: 'avoid' }}
					pt={1}
					pb={1}
					_hover={{ cursor: data?.getIntermediarySaleProfessionalRequestByNumber?.id ? 'zoom-in' : 'auto' }}
					onMouseDown={() => data?.getIntermediarySaleProfessionalRequestByNumber?.id && onOpen()}
				>
					<Text fontWeight="bold" minW={40} w={40}>
						{lang === 'kh' ? item?.khTitle : item?.enTitle}
					</Text>
					<Flex justifyContent="flex-start" alignItems="baseline">
						<Text ml="4" fontWeight="bold">
							{item?.numDp}
						</Text>
						{loading && <Spinner ml={1} size="xs" color="blue.300" />}
					</Flex>
				</Flex>
			)}
			{isOpen && <IntermediarySaleProfessionalRequestDetailModal id={data?.getIntermediarySaleProfessionalRequestByNumber?.id} onModalClose={onClose} />}
		</>
	);
}

export default AgentCompanySaleStaffTermination;
